import { Component, Inject, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Subject } from 'rxjs';
import { CfFtDialogService } from './add-own-template-dialog.service';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { toHTML } from 'ngx-editor';

@Component({
  selector: 'dl-add-own-template-dialog',
  templateUrl: './add-own-template-dialog.component.html',
  styleUrls: ['./add-own-template-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddOwnTemplateDialogComponent implements OnInit {
  public templateColumn: any;
  public templateData: any;
  public newMessageTemplate: Subject<any> = new Subject<any>();
  public isNewFromTemplate = true;
  public isSaveBtnDisabled: boolean = true;
  public selectedRow = [];
  public textDoc = '';
  public msgTemplateSubjectFormControl = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  public notificationData: any;
  public templateSubject: string = '';
  public templateBody: string = '';
  public allTemplates: any;
  public messageType: string = '';
  public constructor(private cfFtDialogService: CfFtDialogService, private _QnSbnDataService: QnSbnDataService, private qnsbnservice: QnSbnService, private changeDetectorRef: ChangeDetectorRef, private readonly dialog: MatDialog, public dialogRef: MatDialogRef<AddOwnTemplateDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private readonly oneSnackBar?: OneSnackBarService) { }

  public ngOnInit(): void {
    this.templateColumn = this.data.columnData;
    this.templateData = this.data.tableData;
    this.allTemplates = this.data.allTemplates;
    this.messageType = this.data.messageType;
    this._QnSbnDataService.mappingData$.subscribe(observer => {
      this.notificationData = observer['localNotificationId'];
    })
    if (this.templateData.templateDetails) {
      this.templateSubject = this.templateData.templateDetails.templateSubject;
      this.templateBody = this.templateData.templateDetails.templateBody;
      this.msgTemplateSubjectFormControl.setValue(this.templateSubject);
      this.textDoc = this.templateBody;
    }
    this.msgTemplateSubjectFormControl.valueChanges.subscribe(x => {
      this.getSaveButtonStatus();
    });
  }

  public onKeyupSubjectName(evt) {
    evt.preventDefault();
  }

  public onBlurSubjectName(evt) {
    this.msgTemplateSubjectFormControl.setValue(this.msgTemplateSubjectFormControl.value.trim());
  }

  public updateMsgTemplate(): void {
    if (this.templateSubject === this.msgTemplateSubjectFormControl.value && this.templateBody === this.textDoc) {
      this.oneSnackBar.open('Template does not have any changes to update', OneSnackBarType.SUCCESS, '', { duration: 5000 });
      this.isSaveBtnDisabled = true;
      return;
    }

    const templateExist = this.allTemplates.some(template =>
      template.templateDetails.templateBody === this.textDoc &&
      template.templateDetails.templateSubject === this.msgTemplateSubjectFormControl.value);

    if (templateExist) {
      this.oneSnackBar.open('Template already exist with same data. Please verify the template.', OneSnackBarType.SUCCESS, '', { duration: 5000 });
      return;
    }

    let newTemplateData = {};
    let responseMessage = '';
    if (this.templateData.templateId) {
      newTemplateData = {
        "templateId": this.templateData.templateId,
        "templateSubject": this.msgTemplateSubjectFormControl.value,
        "templateBody": this.textDoc,
        "notificationType": this.notificationData.Type,
        "messageType": this.messageType,
        "templateLanguage": this.notificationData.LocalNotificationLanguage
      };
      responseMessage = "Template updated successfully.";
    } else {
      newTemplateData = {
        "templateSubject": this.msgTemplateSubjectFormControl.value,
        "templateBody": this.textDoc,
        "notificationType": this.notificationData.Type,
        "messageType": this.messageType,
        "templateLanguage": this.notificationData.LocalNotificationLanguage
      };
      if (this.messageType === 'Email') {
        responseMessage = "Message template successfully Added.";
      }
      else if (this.messageType === 'Reminder') {
        responseMessage = "Reminder template successfully Added.";
      }
      else {
        responseMessage = "Template successfully Added.";
      }
    }

    this.qnsbnservice.createUpdateMessageTemplate(newTemplateData).subscribe(
      (responseData: any) => {
        this.oneSnackBar.open(responseMessage, OneSnackBarType.SUCCESS, '', { duration: 5000 });

        if (this.messageType === 'Email') {
          this.qnsbnservice.getMessageTemplate(this.notificationData.Type, this.notificationData.LocalNotificationLanguage).subscribe(
            (resData: any) => {
              if (resData.errorMessage) {
                this.oneSnackBar.open(resData.errorMessage.errorMessage, OneSnackBarType.ERROR, '', { duration: 5000 });
              } else {
                // this.displayMessageTemplateDialog(data.MessageTemplates);
                this.dialogRef.close({ data: resData.MessageTemplates, rowIndex: this.data.rowIndex });
              }
            },
            (error: HttpErrorResponse) => {
              // console.log('error:', error);
              this.qnsbnservice.httpErrorHandler(error, 'Could not fetch message templates.');
            }
          );
        }

        if (this.messageType === 'Reminder') {
          this.qnsbnservice.getReminderTemplate(this.notificationData.Type, this.notificationData.LocalNotificationLanguage).subscribe(
            (resData: any) => {
              if (resData.errorMessage) {
                this.oneSnackBar.open(resData.errorMessage.errorMessage, OneSnackBarType.ERROR, '', { duration: 5000 });
              } else {
                this.dialogRef.close({ data: resData.MessageTemplates, rowIndex: this.data.rowIndex });
              }
            },
            (error: HttpErrorResponse) => {
              // console.log('error:', error);
              this.qnsbnservice.httpErrorHandler(error, 'Could not fetch Reminder templates.');
            }
          );
        }
        // this.dialogRef.close({ data: responseData, rowIndex: this.data.rowIndex });
      },
      (error: HttpErrorResponse) => {
        // console.log('error:', error);
        this.qnsbnservice.httpErrorHandler(error, 'Could not save Template.');
      }
    );
    this.changeDetectorRef.detectChanges();
  }

  public getSelectedRowInTemplate(rows: any): void {
    this.selectedRow = rows.messageSelected;
    const isSelected = this.selectedRow.length > 0;
  }

  public setRTETextadd(evt): void {
    this.textDoc = toHTML(evt);
    this.getSaveButtonStatus();
  }

  public getSaveButtonStatus(): void {
    if (this.msgTemplateSubjectFormControl.status === 'VALID' && this.textDoc && this.textDoc !== '<p></p>') {
      this.isSaveBtnDisabled = false;
    } else {
      this.isSaveBtnDisabled = true;
    }
  }
}
